import axios from 'axios'

export { processErrors, processSuccess } from 'jsonapi-helper'

export const PaApi = () => {
  setAxiosApi()

  return axios
}

const getHostname = () => {
  let hostname = window.location.hostname
  let hn = hostname.split('.')

  if (hn[0] === 'admin') {
    return hn.slice(1).slice(-2)[0]
  } else {
    let subHostname = hn[0].split('-')
    let newHostname = subHostname[0]

    if (subHostname[1] === 'dev') {
      newHostname = newHostname + '-' + subHostname[1]
    }

    return newHostname
  }
}

export const setAxiosApi = () => {
  const subdomain = getHostname()
  const host = [ subdomain + '-api' ].concat(
    window.location.host.split('.').slice(-2)
  )

  let url = 'https://' + host.join('.')
  if (window.location.hostname === 'localhost') {
    url = 'https://avxw-dev-api.ngrok.io'
  }

  axios.defaults.baseURL = url
  if (window.location.hostname === 'localhost') {
    axios.defaults.baseURL = 'https://avxw-dev-api.ngrok.io'
  }

  axios.defaults.baseURL += '/'
  axios.defaults.headers.common['Accept'] = 'application/json'
  axios.defaults.headers.common['X-Auth-Key'] = AuthKey()
  axios.defaults.headers.common['X-Auth-Token'] = AuthToken()

  return axios
}

export const AuthLocalKey = () => {
  return 'auth'
}

export const AuthKey = () => {
  const token = JSON.parse(localStorage.getItem(AuthLocalKey()) || '{}')

  return token['X-Auth-Key']
}

export const AuthToken = () => {
  const token = JSON.parse(localStorage.getItem(AuthLocalKey()) || '{}')

  return token['X-Auth-Token']
}

export const baseOpts = {
  attr_includes: true
}



// WEBPACK FOOTER //
// ./src/services/PaApi.js